import React from 'react';
import { Phone, Search, Mail, Share2 } from 'lucide-react';
import Telemerketing from '../assets/telemarekting.png'
import Digital from '../assets/digital-ads.png'
import Email from '../assets/green-emial.png'
import Media from '../assets/green-socmedia.png'


const CONTENT = {
  en: {
    title: "Launch Your Own Amazing Marketing Campaigns",
    subtitle: "Use the same tactics top marketing agencies use:",
    services: [
      { title: "Telemarketing", description: "Use the list to start direct outreach by phone. Talk to office managers, facility directors, or property owners ready to hire." },
      { title: "SEO & Content Strategy", description: "Know your ideal customer better. Use our data to inspire blogs, make new website landing pages, and create resources like office cleaning checklists that attract your buyers." },
      { title: "Email Marketing", description: "Craft personalized email campaigns to generate interest and schedule quotes. With updated contacts, your outreach will hit the mark." },
      { title: "Social Media Outreach", description: "Upload the list into platforms like Facebook or LinkedIn to run hyper-targeted ads or direct messages." },
    ],
  },
  es: {
    title: "Lanza tus propias campañas de marketing increíbles",
    subtitle: "Usa las mismas tácticas que usan las mejores agencias de marketing:",
    services: [
      { title: "Telemarketing", description: "Usa la lista para iniciar contacto directo por teléfono. Habla con gerentes de oficina, directores de instalaciones o propietarios listos para contratar." },
      { title: "SEO y estrategia de contenido", description: "Conoce mejor a tu cliente ideal. Usa nuestros datos para inspirar blogs, crear páginas de destino y recursos como listas de limpieza de oficinas que atraigan a tus compradores." },
      { title: "Email marketing", description: "Crea campañas de correo personalizadas para generar interés y agendar cotizaciones. Con contactos actualizados, tu outreach dará en el blanco." },
      { title: "Contacto por redes sociales", description: "Sube la lista a plataformas como Facebook o LinkedIn para ejecutar anuncios muy dirigidos o mensajes directos." },
    ],
  },
};

const MarketingCampaigns = ({ lang = "en" }) => {
  const t = CONTENT[lang] || CONTENT.en;
  const services = [
    { icon: Telemerketing, ...t.services[0] },
    { icon: Digital, ...t.services[1] },
    { icon: Email, ...t.services[2] },
    { icon: Media, ...t.services[3] },
  ];

  return (
    <section className="py-16 bg-[#B0E7EF]">
      <div className="container mx-auto max-w-5xl px-4 md:px-0">
        <div className="text-center mb-12">
          <h2 className="text-3xl text-[#1465B7] font-bold mb-4">
            {t.title}
          </h2>
          <p className="text-[#314F6D] text-2xl">
            {t.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-9">
          {services.map((service, index) => (
            <div key={index}>
              <div className="w-40 h-40 bg-white rounded-full flex items-center justify-center mx-auto mb-4 border-2 border-[#1465B7]">
                <img src={service.icon} width={100}/>
                {/* <service.icon className="w-8 h-8 text-green-600" /> */}
              </div>
              <h3 className="text-xl text-[#26A94A] font-bold mb-3 text-center">
                {service.title}
              </h3>
              <p className="text-[#2D4B6A] font-medium text-lg leading-relaxed text-center">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketingCampaigns;